const apis = ()=>{
const baseUrl = 'http://localhost:3000/'
    const list = {

        registeUser:`${baseUrl}user/register`
    }

    return list
}

export default apis